import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TripServices from '../../../../../services/firstAndLastmilemanagement.service';
import Multiselect from 'vue-multiselect'
import podUploadComponent from '../../../../../../shared/components/podUploadComponent'
import MasterService from '../../../../../../masterdata/services/masterdata.service'
import Util from '../../../../../../shared/util/util'
import Pagination from '../../../../../../shared/components/pagination';
import CONSTANT from '../../../../../../shared/constants/constant';
import XLSX from "xlsx";

export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    VueElementLoading,
    TripServices,
    podUploadComponent,
    Multiselect,
    MasterService,
    Pagination
  },

  props:['parentObj'],

  data() {
    return {
        userdetail : '',
        userName : '',
        defaultHubID : '',
        podDetail : [{
          "awb" : '',
          "podqc": null,
          "badpodreason": '',
          "comments": '',
          "reviewstatus": '',
          "podurl": '',
          "uploadedPod": [],
          "selectedBrowsedPodsToUploadS3": [],
          "selectedBrowsedPodsToUploadS3Save": [],
          "selectedScannedPodsToUploadS3": [],
          "selectedCameraPodsToUploadS3":[],
          "error": false,
          "showAllOptions": false,
          "presignHubImage": [],
          "documentscanned": 0,
          "uploadedHubImage": [],
          "disableBrowseImageButton" : false,
          "disableCameraImageButton" : false,
          "disableScannerImageButton": false,
          "disabledDeleteImageButton": false
        }],
        companyNamelist:[],
        companyNameSearch : null,
        AWB:'',
        HubList : [],
        destinationSearch : null,
        deliveryfromdate : null,
        deliverytodate :  null,
        ageOptions : [
          { 
          'value' : 'lt1',
          'text' : '<1'
          },
          { 
          'value' : '1to3',
          'text' : 'Between 1 and 3'
          },
          { 
          'value' : 'gt3',
          'text' : '>3'
          },
        ],
         ageValue : null,
         visible : false,
         isLoading : false,
         currentPage: 1,
         totalPage: 0,
         totalCount:0,
         offset:0,
         pageLimit:CONSTANT.PER_PAGE_DATA,
		 srUserList: [],
		 srUserId: null,
		 srUserEmail: '',
		 userType:'',
		 srUser:'',
		 srid:'',

    }
  },
  computed: {
    maxFromDate() {
      // Calculate the max from date (Today)
      const today = new Date();
      return today.toISOString().split('T')[0];
    },
    minFromDate() {
      // Calculate the min from date (90 days less than the current date)
      const minFromDate = new Date();
      minFromDate.setDate(minFromDate.getDate() - 90);
      return minFromDate.toISOString().split('T')[0];
    },
    maxToDate() {
      // Calculate the max to date (1 month greater than the from date)
      if (this.deliveryfromdate) {
        const maxToDate = new Date(this.deliveryfromdate);
        maxToDate.setMonth(maxToDate.getMonth() + 1);
        return maxToDate.toISOString().split('T')[0];
      }
      return '';
    },
    minToDate() {
      // Minimum to date should be equal to the from date
      return this.deliveryfromdate;
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID[0];
	let queryParams = this.$route.query;
	if(queryParams && Object.keys(queryParams).length){
		this.srid = queryParams.userid;
	}
	await this.getSRListing()
	await Promise.all([
		this.getHublist(),
		this.getCompanyShortName(),
		this.getListForPodReupload()
	]);
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getListForPodReupload();
    },
   async onSubmitSearch(){
    this.currentPage = 1;
    this.offset = 0;
    this.$validator.validateAll("podreupload").then(async (result) => {
      if (result) {
       this.getListForPodReupload()
      }
    }).catch((err) => {
      console.log('errors exist',err);
      return false;
    });
   },
    async getListForPodReupload(type){
		try {
			this.isLoading = true;
			let inputPayload = {
				"hubid":[this.defaultHubID],
				"allocationtype":"LM",
				"offset": this.offset,
				"limit": this.pageLimit,
			  }
			  let srid = []
			  if(this.srUserId && Object.keys(this.srUserId).length){
				this.srUserId.forEach(item=>{
					srid.push(item.id);
				})
				inputPayload.userid = srid;
			  }else if(this.srid){
				inputPayload.userid = [this.srid];
			  }
			  if(this.AWB.trim()){
					  let awbnumbers = this.AWB.trim().split(/[\n,' ']+/)
					  let awbarr = awbnumbers.filter(function (n) { return n !== "" });
					  if(awbarr.length>10){
						this.$alertify.error("Maximum 10 AWB Allowed","","error");
						this.isLoading = false;
						this.multipleawbflag= true;
					  }else{
						this.multiawbflag = true;
						inputPayload.awb = awbarr
					  }
			 }
			let clientbusinessaccountidarr = []
			if (this.companyNameSearch && this.companyNameSearch.length > 0) {
			  this.companyNameSearch.forEach(element => {
				clientbusinessaccountidarr.push(element.clientbusinessaccountid)
			  });
			  inputPayload.clientbusinessaccountid = clientbusinessaccountidarr
			}
			if (this.deliveryfromdate && this.deliverytodate) {
			  inputPayload.deliverydate = [this.deliveryfromdate,this.deliverytodate]
			}
			let hubidarr = [];
			if (this.destinationSearch && this.destinationSearch.length > 0) {
			  this.destinationSearch.forEach(element => {
				hubidarr.push(element.value)
			  });
			  inputPayload.hubid = hubidarr
			}
			if (this.ageValue) {
			  inputPayload.age = this.ageValue.value
			}
			if (type == 'download') {
			  inputPayload.downloadflag == 1;
			}
			  this.isLoading = true;
			  let result = await TripServices.getListForPodReupload(inputPayload);
			  if(result.data.code == 200){
				this.totalCount = result.data.data.count;
				let podData = result.data.data.data
				if (type == 'download') {
				  this.downloadPendingPodData(podData)
				  this.isLoading = false
				  return ;
				}
				this.podDetail = podData.map(element => ({
					awb: element.awb,
					podqc: element.podqc ? (element.podqc === 'good' ? 1 : 2) : null,
					badpodreason: element.badpodreason ? element.badpodreason.split(',') : null,
					comments: element.podcomments || 'NA',
					reviewstatus: 'false',
					podurl: '',
					uploadedPod: [],
					selectedBrowsedPodsToUploadS3: [],
					selectedBrowsedPodsToUploadS3Save: [],
					selectedScannedPodsToUploadS3: [],
					selectedCameraPodsToUploadS3: [],
					error: false,
					presignHubImage: [],
					uploadedHubImage: [],
					documentscanned: 0,
					disableBrowseImageButton: false,
					disableCameraImageButton: false,
					disableScannerImageButton: false,
					disabledDeleteImageButton: false,
					clientname: element.clientname,
					destinationhubname: element.destinationhubname,
					deliverydatetime: Util.displayDateTimeFormat(element.deliverydatetime),
					username: element.username,
					userid: element.userid,
					createddate: element.createddate,
					age: element.age,
					tripid: element.tripid,
					podSaved: false
				}));	
			  }else{
				this.podDetail = [];
				this.$alertify.error("No Record found","","error");
			  }
			  this.isLoading = false;
			  this.totalPage = this.totalCount < this.pageLimit ? 1 : Math.ceil(this.totalCount / this.pageLimit);
		} catch (error) {
			this.isLoading = false;
			console.log(error);
		}
    },
    downloadPendingPodData(data){
      let downloadarr = []
      for (let i = 0; i < data.length; i++) {            
        const element = data[i];
        let obj = {
          "awb" : element.awb,
          "clientname" : element.clientname,
          "destinationhubname" : element.destinationhubname,
          "deliverydatetime" : Util.displayDateTimeFormat(element.deliverydatetime),
          "username" : element.username,
          "userid" : element.userid,
          "createddate" : element.createddate,
          "age" : element.age,
          'status' : element.status
        }
        downloadarr.push(obj)
      }
      const data1 = XLSX.utils.json_to_sheet(downloadarr);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, data1, 'data')
			XLSX.writeFile(wb,'PendingPodReport.xlsx');
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        this.isLoading = true;
        let result = await TripServices.getActiveInactiveClientList()
        this.isLoading = false;
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName,
            'clientbusinessaccountid' : CompanyShortList[i].ClientBusinessAccountId
          })
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async getHublist() {
      try {
        let InputPayload = {};
        this.isLoading = true;
        let result = await MasterService.GetHublist(InputPayload);
        this.isLoading = false;
        let HubList = result.data.data.data;
        for (var i = 0; i < HubList.length; i++) {
          this.HubList.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
          });
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    handleCustomEvent(data) {
      this.visible = false
    },
    async updateList(data) {
      this.podDetail.forEach(item => {
        if (item.awb == data.awb) {
          item.podSaved = true;
        }
      });
    },
	preFillSRData(item){
		this.srUserId = [{
			id:item.userid,
			label:`${item.srname} (${item.userid})`,
			sremail:item.email,
			emptype:item.emptype,
			olddelveryuseroruserid:item.olddelveryuseroruserid,
		}]
	},
	async getSRListing() {
		try {
		  this.isLoading = true;
		  this.srUserList = []
		  let InputPayload = {
			HubId: [this.defaultHubID]
		  };
		  let result = await TripServices.getSRList(InputPayload);
		  let SRList = await result.data.data;
			SRList.forEach(item=>{
			  if(this.srid && item.userid == this.srid){
				this.preFillSRData(item);
			  }
			  this.srUserList.push({
				id:item.userid,
				label:`${item.srname} (${item.userid})`,
				sremail:item.email,
				emptype:item.emptype,
				olddelveryuseroruserid:item.olddelveryuseroruserid,
			  })
			})
			this.isLoading = false;
		} catch (err) {
		  this.isLoading = false;
		  console.log(err);
		}
	  },
	  selectSRUser(user) {
		this.srUser = user.label
		this.srUserId = user
		this.srUserEmail = user.sremail
		this.userType = user.emptype
	 },
    resetFilters(){
      this.companyNameSearch = null
      this.destinationSearch = null
      this.deliveryfromdate = null
      this.deliverytodate = null
      this.AWB = ''
      this.ageValue = null
	  this.srUserId = null
	  this.srid = null
      this.getListForPodReupload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/closeTrip/podReupload/podReupload.component.js